import { FETCH_LANGUAGES_FAILURE, FETCH_LANGUAGES_REQUEST, FETCH_LANGUAGES_SUCCESS } from "../type";

const initialState = {
  languages: [],
  loading: false,
  error: null,
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LANGUAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_LANGUAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        languages: action.payload,
      };

    case FETCH_LANGUAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default languageReducer;